import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import useSessionStorage from '../../hooks/useSessionStorage'
import { initialFields } from '../../consts'

export default function Nif({ label, title, required = true }) {
  const {
    register,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext()

  const [storageData, setStorageData] = useSessionStorage(
    'app_data',
    initialFields
  )

  const tipoDocumento = watch('MCCPERSTAG.TOMADOR.TipoDocumento') || 'NIF'
  const isPasaporte = tipoDocumento === 'PASAPORTE'
  const maxLength = isPasaporte ? 15 : 9
  const docLabel = label || tipoDocumento
  const docName = (tipo) => (tipo === 'PASAPORTE' ? 'pasaporte' : tipo)

  const handleChange = (event) => {
    if (event.target.value.length > maxLength) {
      setValue(
        'MCCPERSTAG.TOMADOR.Nif',
        event.target.value.substring(0, maxLength)
      )
    }
    if (event.target.value.length >= (isPasaporte ? 5 : 9)) {
      setStorageData(getValues())
    }
  }

  function validateNIF(value, tipo) {
    var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET'
    var nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]$/i
    var nieRexp = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i
    var pasaporteRexp = /^[A-Z0-9]{5,15}$/i
    var str = value.toString().toUpperCase()

    if (tipo === 'PASAPORTE') return pasaporteRexp.test(str)
    if (tipo === 'NIE' && !nieRexp.test(str)) return false
    if (tipo !== 'NIE' && !nifRexp.test(str)) return false

    var nie = str.replace(/^[X]/, '0').replace(/^[Y]/, '1').replace(/^[Z]/, '2')

    var letter = str.substr(-1)
    var charIndex = parseInt(nie.substr(0, 8)) % 23

    if (validChars.charAt(charIndex) === letter) return true
    return false
  }

  return (
    <div className="form-field">
      {title && <span>{title}</span>}
      <div className="form-group">
        <label htmlFor="MCCTARITAG.TOMADOR.Nif">{docLabel}</label>
        <input
          type="text"
          id="MCCTARITAG.TOMADOR.Nif"
          className={`form-control${
            errors.MCCPERSTAG?.TOMADOR?.Nif ? ' hasError' : ''
          }`}
          placeholder={docLabel}
          {...register('MCCPERSTAG.TOMADOR.Nif', {
            onChange: handleChange,
            required:
              required === true
                ? `El ${docName(tipoDocumento)} es obligatorio.`
                : false,
            validate: (value) => {
              const tipo =
                getValues('MCCPERSTAG.TOMADOR.TipoDocumento') || 'NIF'
              if (validateNIF(value, tipo) === false) {
                return `Debe introducir un ${docName(tipo)} válido.`
              }
              return true
            },
          })}
        />
        {errors.MCCPERSTAG?.TOMADOR.Nif && (
          <div className="error">{errors.MCCPERSTAG.TOMADOR.Nif.message}</div>
        )}
      </div>
    </div>
  )
}
